import React, { useState } from 'react';
import { PropertyDetails, EstimationResult } from '../types';
import { EstimationPanel } from './EstimationPanel';
import { Calculator, Briefcase } from 'lucide-react';

export type EstimationPanelWithTabsMode = 'full' | 'conciergerie_only';

interface EstimationPanelWithTabsProps {
  mode?: EstimationPanelWithTabsMode;
  initialData?: PropertyDetails;
  onResult?: (result: EstimationResult) => void;
  showInModal?: boolean;
  onClose?: () => void;
}

const TAB_CONCIERGERIE = 'conciergerie';
const TAB_SUBLETTING = 'sous_location_pj';

export const EstimationPanelWithTabs: React.FC<EstimationPanelWithTabsProps> = ({
  mode = 'full',
  initialData,
  onResult,
  showInModal = false,
  onClose,
}) => {
  const [activeTab, setActiveTab] = useState<string>(TAB_CONCIERGERIE);

  if (mode === 'conciergerie_only') {
    return (
      <EstimationPanel
        initialData={initialData}
        onResult={onResult}
        showInModal={showInModal}
        onClose={onClose}
      />
    );
  }

  return (
    <div className={showInModal ? 'p-6' : 'p-8'}>
      {!showInModal && (
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-slate-900">
            Outil d'Estimation
          </h1>
          <p className="text-slate-500 mt-1">
            Conciergerie ou sous-location — estimez les revenus locatifs
          </p>
        </div>
      )}

      <div className="flex border-b border-slate-200 mb-6 gap-1">
        <button
          type="button"
          onClick={() => setActiveTab(TAB_CONCIERGERIE)}
          className={`flex items-center gap-2 px-4 py-3 text-sm font-medium rounded-t-lg transition-colors border-b-2 -mb-px ${
            activeTab === TAB_CONCIERGERIE
              ? 'border-amber-500 text-amber-600 bg-amber-50/50'
              : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-slate-50'
          }`}
        >
          <Calculator className="w-4 h-4" />
          Conciergerie
        </button>
        <button
          type="button"
          onClick={() => setActiveTab(TAB_SUBLETTING)}
          className={`flex items-center gap-2 px-4 py-3 text-sm font-medium rounded-t-lg transition-colors border-b-2 -mb-px ${
            activeTab === TAB_SUBLETTING
              ? 'border-amber-500 text-amber-600 bg-amber-50/50'
              : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-slate-50'
          }`}
        >
          <Briefcase className="w-4 h-4" />
          Sous-location
        </button>
      </div>

      {activeTab === TAB_CONCIERGERIE && (
        <EstimationPanel
          initialData={initialData}
          onResult={onResult}
          showInModal={showInModal}
          onClose={onClose}
          hideTitle
        />
      )}
      {activeTab === TAB_SUBLETTING && (
        <iframe
          src="/subletting-estimator.html"
          title="Simulateur sous-location"
          className="w-full min-h-[800px] border-0 rounded-xl overflow-hidden bg-transparent"
        />
      )}
    </div>
  );
};
